import React, { useCallback } from "react";
import { createServiceFormValidator } from "../../validators";
import { Form } from "react-final-form";
import Paper from "@material-ui/core/Paper";
import { Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import makeStyles from "@material-ui/core/styles/makeStyles";
import arrayMutators from "final-form-arrays";
import ServiceForm from "../../components/admin/ServiceForm";
import { AdapterLink } from "../../../../components/Adopter";
import { useHistory } from "react-router";
import { useSnackbar } from "notistack";
import { Routes } from "../../../../constants/routes";
import { mutateErrors } from "../../../../utils";
import { FORM_ERROR } from "final-form";
import useServiceQueries from "../../hooks/useServiceQueries";
import { queryCache } from "react-query";
import { QUERY_KEYS } from "../../../../constants";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: 35,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      padding: 15,
    },
  },
}));

export default function CreatePage() {
  const classes = useStyles();
  const { fetchCreate } = useServiceQueries();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const { services } = QUERY_KEYS;

  const create = useCallback(
    async (data) => {
      try {
        await fetchCreate(data);
        await queryCache.invalidateQueries(services);
        history.push(`/0/${Routes.SERVICES_ADMIN}`);
        enqueueSnackbar("Success", { variant: "success" });
      } catch (e) {
        const { errors, message } = mutateErrors(e);
        enqueueSnackbar(message, { variant: "error" });
        return { [FORM_ERROR]: message, ...errors };
      }
    },
    [fetchCreate],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container maxWidth="md" className={classes.container}>
      <Breadcrumbs>
        <AdapterLink to="/0">Home</AdapterLink>
        <AdapterLink to="/0/service">Services</AdapterLink>
        <Typography color="textPrimary">Create</Typography>
      </Breadcrumbs>
      <Paper>
        <Form
          onSubmit={create}
          validate={createServiceFormValidator}
          mutators={{
            ...arrayMutators,
          }}
          component={ServiceForm}
        />
      </Paper>
    </Container>
  );
}
